import styled from 'styled-components';
import { Spacer } from '@zillow/constellation';

export const SliderInputContainer = styled(Spacer)`
  width: 50%;
  max-width: calc(50% - 12px);

  @media (max-width: 649px) {
    width: 100%;
    max-width: 100%;
    padding: 16px 0;
  }
`;
